// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__nlFan","additionalInfo":"AgreementModal_additionalInfo__3-B1u"};